import React from 'react';
import { Header } from '@amzn/awsui-components-react-v3/polaris';
// The base no-unused-vars rule does not see type-only uses.
// eslint-disable-next-line no-unused-vars
import ListTable, { ListColumn } from '../../Common/ListTable';
import { ARC_FILTERING_PLACEHOLDER, describeArc } from '../../../utils/arcRows';
import { formatLocale } from '../../../utils/locales';
// eslint-disable-next-line no-unused-vars
import { MATCH_BANDS, PreviewRow } from './scopingModels';

const ARC_COLUMNS: ListColumn<PreviewRow>[] = [
  {
    id: 'sourceLocale',
    header: 'Source locale',
    cell: (row): string => formatLocale(row.languagePair.sourceLocale),
  },
  {
    id: 'targetLocale',
    header: 'Target locale',
    cell: (row): string => formatLocale(row.languagePair.targetLocale),
  },
];

const TER_COLUMN: ListColumn<PreviewRow> = {
  id: 'ter',
  header: 'TER',
  cell: (row): string => row.ter || '',
};

const WEIGHT_COLUMNS: ListColumn<PreviewRow>[] = MATCH_BANDS.map(({ band, label }) => ({
  id: band,
  header: label,
  cell: (row): string => row[band],
}));

const MULTIPLIER_COLUMNS = [...ARC_COLUMNS, TER_COLUMN, ...WEIGHT_COLUMNS];
const FIXED_COLUMNS = [...ARC_COLUMNS, ...WEIGHT_COLUMNS];

interface ScopingModelPreviewProps {
  rows: PreviewRow[];
  // Whether a band uses a TER multiplier, so the rows carry each arc's TER.
  multiplier: boolean;
}

/** The match-band weights the model gives each arc, before saving. */
const ScopingModelPreview = ({ rows, multiplier }: ScopingModelPreviewProps): JSX.Element => {
  return (
    <ListTable
      id="scopingModelPreview"
      items={rows}
      columns={multiplier ? MULTIPLIER_COLUMNS : FIXED_COLUMNS}
      filterText={(row): string => describeArc(row.languagePair)}
      filteringPlaceholder={ARC_FILTERING_PLACEHOLDER}
      header={
        <Header
          variant="h2"
          counter={`(${rows.length})`}
          description={
            multiplier
              ? 'The weights per arc; a TER multiplier at its TER in the TER group, rounded half up to 2 decimal places.'
              : 'The weights per base-rate arc that is not excluded.'
          }
        >
          Preview
        </Header>
      }
      empty="No arcs to weight."
    />
  );
};

export default ScopingModelPreview;
